"use strict";
import { Flex, Text } from "ui/src";
import { Unitag } from "ui/src/components/icons/Unitag";
import { fonts, spacing } from "ui/src/theme";
import { UNITAG_SUFFIX } from "features/unitags/constants";
export function UnitagName({
  name,
  opacity = 1,
  animateText = false,
  animateIcon = false,
  displayIconInline = false,
  displayUnitagSuffix,
  textProps
}) {
  const iconContainerProps = displayIconInline ? {} : {
    position: "absolute",
    right: -spacing.spacing24,
    top: -spacing.spacing4
  };
  return <Flex
    row
    alignSelf="center"
    animation="lazy"
    enterStyle={animateText ? { opacity: 0 } : void 0}
    exitStyle={animateText ? { opacity: 0 } : void 0}
    opacity={opacity}
    alignItems="center"
  >
      <Text
    color="$neutral1"
    fontFamily="$heading"
    fontWeight={fonts.heading2.fontWeight}
    lineHeight={fonts.heading2.lineHeight}
    {...textProps}
  >
        {name}
      </Text>
      {displayUnitagSuffix && <Text
    color="$neutral2"
    fontFamily="$heading"
    fontWeight={fonts.heading2.fontWeight}
    lineHeight={fonts.heading2.lineHeight}
    {...textProps}
  >
          {UNITAG_SUFFIX}
        </Text>}
      <Flex
    {...iconContainerProps}
    row
    animation="lazy"
    ml="$spacing4"
    enterStyle={animateIcon ? { opacity: 0, scale: 0.8, x: 20 } : void 0}
    exitStyle={animateIcon ? { opacity: 0, scale: 0.8, x: -20 } : void 0}
  >
        <Unitag size="$icon.24" />
      </Flex>
    </Flex>;
}
